import React from 'react'

function INcircle() {
  return (
    <span>
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.0166 0C7.40153 0 0.416626 6.9849 0.416626 15.6C0.416626 24.2151 7.40153 31.2 16.0166 31.2C24.6317 31.2 31.6166 24.2151 31.6166 15.6C31.6166 6.9849 24.6317 0 16.0166 0ZM10.1614 7.0239C11.256 7.0239 11.9853 7.7532 11.9853 8.7256C11.9853 9.698 11.256 10.4273 10.0405 10.4273C8.94593 10.4286 8.21663 9.698 8.21663 8.7256C8.21663 7.7532 8.94593 7.0239 10.1614 7.0239ZM12.1166 22.1H8.21663V11.7H12.1166V22.1ZM25.1166 22.1H21.4454V16.4164C21.4454 14.8447 20.4665 14.482 20.0999 14.482C19.7333 14.482 18.5087 14.7238 18.5087 16.4164C18.5087 16.6582 18.5087 22.1 18.5087 22.1H14.7166V11.7H18.51V13.1508C18.9988 12.3045 19.9777 11.7 21.8133 11.7C23.6489 11.7 25.1166 13.1508 25.1166 16.4164V22.1Z" fill="#007BFF"/>
        </svg>
    </span>
  )
}

export default INcircle